import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Box, Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Icon } from "@iconify/react";
import Loader from '../../../components/loader';
import '../ecosystemPartners.css';
import { ecosytemIntegatorGetById } from '../ecosystemPartners.service';
import { EcosytemIntegratorConstants } from '../../../constant/ecosystem/ecosystemConst'

const EcosystemPartnersView = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const { ECOSYSTEMVIEW } = EcosytemIntegratorConstants()
  const [ecosystemData, setEcosystemData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getEcosystemData();
  }, []);

  const getEcosystemData = async () => {
    try {
      const data = await ecosytemIntegatorGetById(id);
      setEcosystemData(data.data);
    } catch (error) {
    };
  }

  return (
    <Box>
      <Grid container alignItems={'center'}>
        <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3 }}>
          <Typography style={{ fontSize: 30, fontWeight: 700 }}>{ECOSYSTEMVIEW.HEADER}</Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 7.5, md: 8.5, lg: 8.5, xl: 8.5 }} textAlign={'end'}>
          <Button variant="contained" className='createBtn' type="submit" onClick={() => { setLoading(true); navigate(`/ecosystemPartnersCreation/${id}?type=edit`) }}>Edit</Button>
        </Grid>
        <Grid size={{ xs: 2, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }} textAlign={'end'}>
          <Icon icon="ei:arrow-left" data-testid="back-icon" onClick={() => navigate('/ecosystemPartners')} width="30" height="30" className='backIcon'  />
        </Grid>
      </Grid>

      <Grid container mt={2}>
        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
          <Grid container mt={2}>
            <Grid size={{ xs: 6, sm: 6, md: 5, lg: 5, xl: 5 }}>
              <Typography className='contentLeft'>{ECOSYSTEMVIEW.TEXT_ONE}</Typography>
            </Grid>
            <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
              <Typography className='contentLeft'> :</Typography>
            </Grid>
            <Grid size={{ xs: 5, sm: 5, md: 6, lg: 6, xl: 6 }}>
              <Typography className='contentRight'>{ecosystemData?.integratorUser?.[0]?.ecosystemIntegratorName ?? "-"}</Typography>
            </Grid>
          </Grid>

          <Grid container mt={2}>
            <Grid size={{ xs: 6, sm: 6, md: 5, lg: 5, xl: 5 }}>
              <Typography className='contentLeft'>{ECOSYSTEMVIEW.TEXT_TWO}</Typography>
            </Grid>
            <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
              <Typography className='contentLeft'> :</Typography>
            </Grid>
            <Grid size={{ xs: 5, sm: 5, md: 6, lg: 6, xl: 6 }}>
              <Typography className='contentRight'>{ecosystemData?.integratorUser?.[0].integratorCountry?.name ?? "-"}</Typography>
            </Grid>
          </Grid>

          <Grid container mt={2}>
            <Grid size={{ xs: 6, sm: 6, md: 5, lg: 5, xl: 5 }}>
              <Typography className='contentLeft'>{ECOSYSTEMVIEW.TEXT_THREE}</Typography>
            </Grid>
            <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
              <Typography className='contentLeft'> :</Typography>
            </Grid>
            <Grid size={{ xs: 5, sm: 5, md: 6, lg: 6, xl: 6 }}>
              <Typography className='contentRight'>{ecosystemData?.integratorUser?.[0]?.integratorType ?? "-"}</Typography>
            </Grid>
          </Grid>

          <Grid container mt={2}>
            <Grid size={{ xs: 6, sm: 6, md: 5, lg: 5, xl: 5 }}>
              <Typography className='contentLeft'>{ECOSYSTEMVIEW.TEXT_FOUR}</Typography>
            </Grid>
            <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
              <Typography className='contentLeft'> :</Typography>
            </Grid>
            <Grid size={{ xs: 5, sm: 5, md: 6, lg: 6, xl: 6 }}>
              <Typography className='contentRight'>
                {ecosystemData?.integratorUser?.[0]?.integratorSolution?.map((type) => type?.name).join(', ')}
              </Typography>
            </Grid>
          </Grid>

          <Grid container mt={2}>
            <Grid size={{ xs: 6, sm: 6, md: 5, lg: 5, xl: 5 }}>
              <Typography className='contentLeft'>{ECOSYSTEMVIEW.TEXT_FIVE}</Typography>
            </Grid>
            <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
              <Typography className='contentLeft'> :</Typography>
            </Grid>
            <Grid size={{ xs: 5, sm: 5, md: 6, lg: 6, xl: 6 }}>
              <Typography className='contentRight'>{ecosystemData?.email ?? "-"}</Typography>
            </Grid>
          </Grid>

          <Grid container mt={2}>
            <Grid size={{ xs: 6, sm: 6, md: 5, lg: 5, xl: 5 }}>
              <Typography className='contentLeft'>{ECOSYSTEMVIEW.TEXT_SIX}</Typography>
            </Grid>
            <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
              <Typography className='contentLeft'> :</Typography>
            </Grid>
            <Grid size={{ xs: 5, sm: 5, md: 6, lg: 6, xl: 6 }}>
              <Typography className='contentRight'>{ecosystemData?.phoneNumber ?? "-"}</Typography>
            </Grid>
          </Grid>

        </Grid>
      </Grid>

      {loading && <Loader />}
    </Box>
  );
};

export default EcosystemPartnersView;


